<section>
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (form) {
    <form class="astral-content-width astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
      <section class="astral-section-surface">
        <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1" [useSurfaceErrorPadding]="true">
          <astral-input [control]="form.controls['name']"></astral-input>
        </astral-layout-group>
      </section>
      @for (module of standardModules; track module) {
        <section class="astral-section-surface astral-stack-m">
          <h3 class="astral-section-heading">{{ 'MODULE.NAMES.' + module.name.toUpperCase() | translate }}</h3>
          <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1" [denseBooleanControls]="true">
            @for (feature of module.features; track feature) {
              <astral-toggle [control]="form.controls[feature]"></astral-toggle>
            }
          </astral-layout-group>
        </section>
      }
      @if (publicApiModules.length > 0) {
        <section class="public-api-section astral-stack-m">
          <div class="public-api-section__intro astral-stack-s">
            <hr class="public-api-divider" />
            <h2 class="public-api-heading astral-section-heading">{{ 'USERGROUP.API_ACCESS_HEADER' | translate }}</h2>
          </div>
          @for (module of publicApiModules; track module) {
            <section class="astral-section-surface astral-stack-m">
              <h3 class="astral-section-heading">{{ 'MODULE.NAMES.' + module.name.toUpperCase() | translate }}</h3>
              <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1" [denseBooleanControls]="true">
                @for (feature of module.features; track feature) {
                  <astral-toggle [control]="form.controls[feature]"></astral-toggle>
                }
              </astral-layout-group>
            </section>
          }
        </section>
      }
    </form>
  }
</section>
